import { useMemo } from 'react';
import { get } from 'lodash';
import { formatNumber } from '../util/data';

/**
 * Custom hook to extract and format listing data
 * @param {Object} params
 * @param {Object} params.listing - The listing object
 * @returns {Object} - Formatted listing data
 */
const useListingData = ({ listing }) => {
  const listingData = useMemo(() => {
    if (!listing) {
      return null;
    }

    // Extract listing data
    const publicData = listing?.attributes?.publicData || {};
    const listingTitle = listing?.attributes?.title || '';

    // Extract and format listing data
    const nearestTown = get(publicData, 'nearestTown.selectedPlace.address', null);
    const acreage = get(publicData, 'location.acreage', 0);
    const formattedAcres = acreage ? formatNumber(acreage) : null;

    return {
      title: listingTitle,
      nearestTown,
      acreage: formattedAcres,
    };
  }, [listing]);

  return listingData;
};

export default useListingData;

